
export default {
  requireProduct: {
    no_permissions: 'No posee los permisos para ingresar a este producto',
    ask_permissions: 'Si desea solicitar la activación de este producto o ya la ha solicitado y aún no lo posee disponible póngase en contacto con nuestro equipo por esta vía y lo contactaremos.',
    message: 'Mensaje',
    go_suite: 'Volver a Suite',
    send_message: 'Enviar mensaje'
  }
}
